import { Dispatch, SetStateAction } from 'react';

export enum DialOptions {
  SUPER_VIEW = 'SuperView',
  ANNOUNCEMENTS = 'Announcements',
  TRANSACTION = 'Transactions',
  BRIDGES = 'Bridges',
  SYS_STATS = 'System Statistics',
  SWITCH_NET = 'Switch Network',
  SETTINGS = 'Settings',
  CONNECTION = 'Connect',
}

export interface IDialContext {
  resetAll: () => void;
  switchDialContent: (opt: DialOptions) => void;
  dialContentState: { [index in DialOptions]: boolean };
  activeDialContent: DialOptions | undefined;
  setIsFullscreen: (state: boolean) => void;
  isFullscreen: boolean;
  setDialOpen: Dispatch<SetStateAction<boolean>>;
  dialOpen: boolean;
  setIsLifiWidgetOpen: Dispatch<SetStateAction<boolean>>;
  isLifiWidgetOpen: boolean;
}

export const defaultState = {
  [DialOptions.TRANSACTION]: false,
  [DialOptions.ANNOUNCEMENTS]: false,
  [DialOptions.BRIDGES]: false,
  [DialOptions.SYS_STATS]: false,
  [DialOptions.SWITCH_NET]: false,
  [DialOptions.SETTINGS]: false,
  [DialOptions.CONNECTION]: false,
  [DialOptions.SUPER_VIEW]: false,
};
